import { Grid } from '@mui/material'
import { format, parseJSON } from 'date-fns'

import { TextInput } from 'components/common'
import { DATE_TIME_FORMAT } from 'constants/index'

import { ReadOnlyBookingAddressType } from '.'

interface IReadOnlyBookingStatus {
  address: ReadOnlyBookingAddressType
  labelAt: string
  labelBy: string
}

export const ReadOnlyBookingAddress = ({ address, labelAt, labelBy }: IReadOnlyBookingStatus) => {
  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12} sm={6}>
        <TextInput
          label={labelAt}
          value={format(parseJSON(address.at as string), DATE_TIME_FORMAT)}
          readOnly
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput
          label={labelBy}
          value={format(parseJSON(address.by as string), DATE_TIME_FORMAT)}
          readOnly
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Title/Company Name' value={address.name} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Town/City' value={address.city} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Address Line 1' value={address.addressLine1} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Address Line 2' value={address.addressLine2} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Postcode' value={address.postcode} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Country' value={address.country} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Contact Name' value={address.contact} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Contact Email' value={address.email} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Telephone Number' value={address.telephoneNumber} readOnly />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput label='Note for Driver' value={address.note} multiline readOnly />
      </Grid>
    </Grid>
  )
}
